import RecoveryPassword from "../components/RecoveryPassword/RecoveryPassword"

const PasswordRecovery = () => {
    return <RecoveryPassword/>
}

export default PasswordRecovery